import React from 'react';
import { SectionHeading } from '../SectionHeading';
const panels = [{
  heading: 'High-positive cutting geometry',
  copy: 'A sharp, open cutting presentation helps the tool shear soft or difficult-to-control material instead of pushing through it.'
}, {
  heading: 'Polished insert faces',
  copy: 'Published MG12 configurations use polished inserts intended to reduce material adhesion at the cutting edge.'
}, {
  heading: 'A modular product system',
  copy: 'Choose the holder size, insert style and replacement components that match the machine setup and work material.'
}];
export function SystemSection() {
  return <section aria-labelledby="system-heading" className="w-full bg-white" data-id="element-327" data-mp="zx93hfe2curs">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-328" data-mp="uvjr9wf3ub24">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-329" data-mp="3klndrqdhz4sb">
          <SectionHeading id="system-heading" eyebrow="THE CUTTING SYSTEM" heading="A high-positive-rake system built to manage the cut" data-id="element-330" data-mp="3fm11bj5htskk" />
          <p className="rp-measure self-end text-[15.5px] leading-[1.7] text-graphite/80" data-id="element-331" data-mp="6a07x8wzzkrb">
            Shear Geometry pairs a rigid external holder with highly polished
            APGX inserts. The legacy product guidance describes geometry
            intended to limit built-up edge and direct chips away from the
            turret in 6061-T6 aluminum, copper and soft aluminum alloys, with
            separate DR80 configurations for titanium.
          </p>
        </div>

        <div className="mt-14 grid gap-px border-t border-rule bg-rule lg:grid-cols-3" data-id="element-332" data-mp="3jimmxtw7f8c0">
          {panels.map((panel, i) => <article key={panel.heading} className="flex flex-col bg-white pt-7 lg:px-8" data-id="element-333" data-mp="39qgwiolloyyx" data-mpi={i}>
              <span className="font-mono text-[10px] tracking-label text-copper" data-id="element-334" data-mp="2vrr2xixzphfb">
                {`0${i + 1}`}
              </span>
              <h3 className="mt-4 font-display text-[19px] font-medium leading-snug text-navy" data-id="element-335" data-mp="2zuncyl9gs57n">
                {panel.heading}
              </h3>
              <p className="mt-3 pb-8 text-[14.5px] leading-[1.65] text-graphite/80" data-id="element-336" data-mp="11ic56rqqe8jb">
                {panel.copy}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}